interface Instruction {
  step?: number;
  img?: string;
  description: string;
  btnName: string;
}
export const instructions:Array<Instruction> = [
  {
    step: 1,
    img: '../assets/arrow.png',
    description: 'Left-click and drag with your mouse or touchpad to look around',
    btnName: 'Next'
  },
  {
    step: 2,
    img: '../assets/wasd.png',
    description: 'Use the WASD or arrow keys on your keyboard to move around the room',
    btnName: 'Next'
  },
  {
    step: 3,
    img: '../assets/shift.png',
    description: 'Move faster by holding the Shift key while moving around the room',
    btnName: 'Close'
  },
]